
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: 'Goods',
components: {
Cell,
Group,
},
data() {
return {
ID: '',
truck: {}
}
},
created() {
this.ID = this.$route.query.ID || ''
this.loadData()
},
methods: {
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'Truck.ashx?action=Form_Query'
this.$post(url, {
TRANS_ID: this.ID
}).then(
response => {
_this.truck = response
_this.$vux.loading.hide()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
}

}



// WEBPACK FOOTER //
// ./src/pages/ys/sh/Goods.vue